import type { FC } from "react";
import { format as dateFormat, formatDistance as dateFnsFormatDistance } from "date-fns";
import { pl } from "date-fns/locale";
import { enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

interface Props {
  date: Date;
  format: string;
}

export const FormatDate: FC<Props> = ({ date, format }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === "pl" ? pl : enUS;

  return <>{dateFormat(date, format, { locale: locale })}</>;
};

export const formatDate = (date: Date, format: string) => {
  const locale = i18n.language === "pl" ? pl : enUS;

  return dateFormat(date, format, { locale: locale });
};

export const formatDistance = (startDate: Date, endDate: Date) => {
  const locale = i18n.language === "pl" ? pl : enUS;

  return dateFnsFormatDistance(startDate, endDate, { locale: locale });
};
